import { InputAdornment } from '@mui/material';
import { ChangeEvent, FC, KeyboardEvent, useState } from 'react';
import { SearchBarProps } from 'src/models/FieldProps.interface';
import {
  SearchBarContainer,
  SearchBarFormControl,
  StyledSearchInput,
  SearchIcon,
} from 'src/components/StyledComponents/StyledSearchBar';

const SearchBar: FC<SearchBarProps> = ({
  id,
  value,
  onChange,
  placeholder = 'Search',
  height = '40px',
  width = '450px',
  maxWidth,
  mt,
}) => {
  const [inputValue, setInputValue] = useState(value);

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onChange(inputValue);
    }
  };

  return (
    <SearchBarContainer mt={mt}>
      <SearchBarFormControl>
        <StyledSearchInput
          id={id}
          value={inputValue}
          onChange={handleSearchChange}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          height={height}
          width={width}
          maxWidth={maxWidth}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon component="i" className="bx bx-search 1" />
            </InputAdornment>
          }
        />
      </SearchBarFormControl>
    </SearchBarContainer>
  );
};

export default SearchBar;
